import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { ICustomerApplicationVariant } from '../../shared/models';
import { ICustomer } from '../../shared/models/customer.model';

@Component({
    selector: 'app-customer-selector',
    templateUrl: './customer-selector.component.html',
    styleUrls: ['./customer-selector.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class CustomerSelectorComponent implements OnInit {

	selectedCustomer: string;
	selectedapplicationVariant: string;
	header = 'Select';
	width = '25%';
	animationSettings: Object = { effect: 'None' };
	hide: any;
	fields: Object = { text: 'customerName', value: 'customerId' };
	customersWaterMark = 'Select one';
	ddwHeight = '220px';
	ddwWidth = '384px';

	userGuid: string;

	@Input() customers: ICustomer[];
	@Input() subscriptions: ICustomerApplicationVariant[];
	@Output() currentCustomer = new EventEmitter<string>();

	@ViewChild('csCustomersddw', { static: true })
	csCustomersddw: DropDownListComponent;

	@ViewChild('csSubscriptionsddw', {static: true})
	csSubscriptionsddw: DropDownListComponent;

	@ViewChild('dialog', { static: true })
	dialog: DialogComponent;
	BtnClick: EmitType<object> = () => {
		this.dialog.show();
	}

	constructor () {

	}

	ngOnInit() {

		if (this.customers && this.customers.length > 0) {

			if (this.customers.length === 1) {
				this.processCustomer(this.customers[0].customerId);
			}

			this.dialog.hide();
		}
	}

	dlgBtnClick: EmitType<object> = () => {

		if (this.selectedCustomer) {
			this.processCustomer(+this.selectedCustomer);
			this.dialog.hide();
		}
	}

	// tslint:disable-next-line: member-ordering
	dlgButtons: Object[] = [{
		click: this.dlgBtnClick.bind(this), buttonModel: { content: 'Get started', isPrimary: true, cssClass: 'e-disabled' }
	}];

	processCustomer(customerToFind: number) {

		let customer;

		if (this.customers && this.customers.length > 0) {

			customer = this.customers.find(c => c.customerId === customerToFind);

			if (customer) {

        this.currentCustomer.emit(customer);

        const button = this.dialog.getButtons()[0];

        if (button) {
          button.cssClass = '';
        }
			}
		}
	}

	customerChanged(event) {
		this.selectedCustomer = event.itemData.customerId;

		if (this.selectedCustomer) {


			const button = this.dialog.getButtons()[0];

			if (button) {
				button.cssClass = '';
			}
		}
	}

	subscriptionChanged(event) {
		this.selectedapplicationVariant = event.itemData.applicationVariantId;

		if (this.selectedapplicationVariant) {
			const button = this.dialog.getButtons()[0];

			if (button) {
				button.cssClass = '';
			}
		}
	}
}

